import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

export default function FAQSection() {
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data || [])).catch(() => {});
  }, []);

  return (
    <section className="bg-white py-16 lg:py-24" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-10">
          <h2 className="text-3xl lg:text-4xl font-extrabold text-txt-900">Questions fréquentes</h2>
          <p className="text-txt-500 mt-2">Tout ce que vous devez savoir sur nos services</p>
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = i === open;
            return (
              <div key={i} className={`border rounded-2xl transition-colors ${isOpen ? "border-brand bg-brand-50/50" : "border-surface-200"}`} data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left"
                >
                  <span className="font-bold text-txt-900 text-sm">{f.question}</span>
                  <ChevronDown size={18} className={`text-txt-500 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-txt-500 text-sm leading-relaxed">{f.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
